import { QuoteException } from '@/domain/stripe/quote/exception/QuoteException'

export class CouldNotCreateQuoteException extends QuoteException {

}